module.exports = __webpack_public_path__ + "img/chat-green.08226c9a.svg";